/*
 * Acessor tipado da config que a página de artigo emite por requisição
 * (`Astrolink/website/artigo.php` → `window.__AL_ARTICLE__`).
 *
 * Espelha `Hooks/Common/useNavigationBack/navConfig.ts`, que faz o mesmo com `window.__AL_NAV__`
 * emitido por `_header_online.php:44` — inclusive nas flags `JSON_HEX_*` do `json_encode` do
 * lado PHP, que são o que impede um título de artigo com `</script>` ou aspas de fechar o bloco.
 *
 * Ausência da global (página sem o bootstrap, ou script que não rodou) devolve `null`, e o
 * módulo não monta nada — sem erro no console de páginas que não são de artigo.
 */
import { IContentTemplateData } from '../../components/container/ArticleTemplate/types';

interface IWindowWithArticleConfig extends Window {
    __AL_ARTICLE__?: Partial<IContentTemplateData>;
}

/**
 * O payload é dado de servidor, não entrada de usuário: aqui só se confere que ele EXISTE e
 * que os campos sem os quais uma região quebraria têm forma. Validar campo a campo duplicaria
 * o contrato de `types.ts` sem ganho — se o PHP mudar a forma, o lugar de descobrir é o build.
 */
export const getArticleConfig = (): IContentTemplateData | null => {
    const raw = (window as IWindowWithArticleConfig).__AL_ARTICLE__;

    if (!raw || !raw.account || !raw.skyMoment) return null;

    return {
        ...raw,
        variation: raw.variation || 'article',
        isLogged: raw.isLogged === true,
        authStep: raw.authStep || '',
        maintenance: raw.maintenance || '',
        hasDownloadApp: raw.hasDownloadApp === true,
        hasSearchDesk: raw.hasSearchDesk === true,
        account: raw.account,
        skyMoment: raw.skyMoment
    } as IContentTemplateData;
};

export default getArticleConfig;
